<template>
  <div class="sign-in-container" :style="`paddingTop:${barHeight}px`">
    <!-- 头部 -->
    <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="back" />
      </template>
    </van-nav-bar>
    <!-- 规则 -->
    <div class="rules" @click="goToRules">{{ $t('lang.call.tit1') }}</div>
    <!-- 标题 -->
    <div class="sign-in-header">
      <span>{{ $t('lang.sevenKeepSignin.title1a') }}</span>
      <span class="dollar-amount">{{ $t('lang.sevenKeepSignin.title1b') }}</span>
      <template v-if="$i18n.locale === 'id'">
        <br />
      </template>
      <span>{{ $t('lang.sevenKeepSignin.title1c') }}</span>
    </div>
    <!-- 签到内容 -->
    <div class="sign-in-wrapper">
      <!-- 内容 -->
      <div class="sign-in-box">
        <!-- 顶部信息 -->
        <div class="header-wrapper">
          <div class="left">
            <div class="total">{{ $t('lang.dl.total') }}</div>
            <div class="coin-wrapper">
              <span>{{ beansAmount }}</span>
              <img :src="getMatchImg('beans')" alt="coin" width="24" height="24" />
              <span>≈&nbsp;{{ `${currencyCode} ${handleCentsToDollars(currencyAmount)}` }}</span>
            </div>
          </div>
          <div class="right">
            <div class="date">
              <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/clock.png" alt="coin" width="16" height="16" />
              <span>{{ handleFormatCountdown }}</span>
            </div>
            <div class="withdraw" @click="goToWithdrawal">
              <!-- 判断语言 -->
              <img v-if="$i18n.locale == 'pt'" src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/withdraw-pt.png" alt="image" width="20" height="20" />
              <img v-else src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/withdraw.png" alt="image" width="16" height="16" />
              <span>{{ $t('lang.sevenKeepSignin.withdraw') }}</span>
            </div>
          </div>
        </div>
        <div class="gift-wrapper">
          <!-- 礼物标题 -->
          <div class="gift-title">
            <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava//star.png" alt="star" width="24" height="24" />
            <span class="title">{{ $t('lang.sevenKeepSignin.subTitle') }}</span>
            <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/star.png" alt="star" width="24" height="24" />
          </div>
          <!-- 礼物卡片 -->
          <div class="gift-card">
            <template v-if="!listLoading">
              <template v-for="item in rewardsList">
                <div :key="item.day" class="card-wrapper">
                  <div :class="['card', item.ifCurDay ? 'now-card' : 'disable-card']">
                    <div class="title">{{ `${$t('lang.sevenKeepSignin.day')} ${item.index}` }}</div>
                    <div class="content">
                      <span>{{ ((item.rewardDataList || [])[0] || {}).rewardPropNumber || '-' }}</span>
                      <img :src="getMatchImg('beans')" alt="image" width="20" height="20" />
                    </div>
                  </div>
                  <!-- 角标 -->
                  <div class="badge">
                    <!-- 已签到过 -->
                    <template v-if="item.ifSigned">
                      <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/on-check.png" width="22" height="22" alt="image" />
                    </template>
                    <!-- 没签到过 -->
                    <template v-else-if="item.index <= currentDay">
                      <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/off-check.png" width="22" height="22" alt="image" />
                    </template>
                    <!-- 还没到日期 -->
                    <template v-else></template>
                  </div>
                </div>
              </template>
              <!-- 最终奖励 -->
              <div v-if="rewardsList.length > 0" class="card-wrapper">
                <div :class="['card', 'final-card']">
                  <div class="final-image">
                    <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/treasure-box.png" alt="image" width="36" height="23" />
                  </div>
                  <div class="content">
                    <span>{{ ((fullSignRewardConfig.rewardDataList || [])[0] || {}).rewardPropNumber || '-' }}</span>
                    <img :src="getMatchImg('beans')" alt="image" width="20" height="20" />
                  </div>
                </div>
                <!-- 角标 -->
                <div class="badge">
                  <img v-if="!ifFullSign" src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/lock.png" width="20" height="20" alt="image" />
                  <img v-else src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/on-check.png" width="20" height="20" alt="image" />
                </div>
              </div>
            </template>
            <template v-else>
              <div class="loading-wrapper">
                <van-loading />
              </div>
            </template>
          </div>
          <!-- 提示 -->
          <div class="tips">{{ $t('lang.sevenKeepSignin.title1') }}</div>
        </div>
      </div>
    </div>
    <!-- 更多标题 -->
    <div class="more-title">
      <div class="gift-title">
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava//star.png" alt="star" width="24" height="24" />
        <span class="title">{{ $t('lang.sevenKeepSignin.earnMore') }}</span>
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/star.png" alt="star" width="24" height="24" />
      </div>
      <div class="tips">{{ $t('lang.sevenKeepSignin.title2') }}</div>
    </div>
    <!-- 更多内容 -->
    <div class="more-wrapper">
      <div class="item" @click="goToInvite">
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/inviting-friends.png" alt="image" width="40" height="40" />
        <div class="title">{{ $t('lang.sevenKeepSignin.more1') }}</div>
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/arrow.png" alt="image" width="30" height="30" />
      </div>
      <div class="item" @click="goToDaily">
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/daily-task.png" alt="image" width="40" height="40" />
        <div class="title">{{ $t('lang.sevenKeepSignin.more2') }}</div>
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/arrow.png" alt="image" width="30" height="30" />
      </div>
      <div class="item" @click="goToCall">
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/match-call.png" alt="image" width="40" height="40" />
        <div class="title">{{ $t('lang.sevenKeepSignin.more3') }}</div>
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/arrow.png" alt="image" width="30" height="30" />
      </div>
      <div class="item" @click="goToChat">
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/chat.png" alt="image" width="40" height="40" />
        <div class="title">{{ $t('lang.sevenKeepSignin.more4') }}</div>
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/arrow.png" alt="image" width="30" height="30" />
      </div>
    </div>
    <!-- WhatApp -->
    <div class="footer">
      <div class="whatapp" @click="goToWhatapp">
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/whatapp.png" alt="coin" width="24" height="24" />
        <span>WhatApp</span>
      </div>
      <div class="whatapp-text">{{ $t('lang.sevenKeepSignin.whatapp') }}</div>
    </div>
    <!-- 弹窗 -->
    <van-dialog v-model="popupVisible" title="" :showConfirmButton="false" :showCancelButton="false" className="van-dia-class">
      <div class="dialog-wrapper">
        <div class="header">{{ $t('lang.sevenKeepSignin.subTitle') }}</div>
        <div class="content">
          <div class="amount">
            <span>{{ rewardsInfo.rewardBeanNum || '-' }}</span>
            <img :src="getMatchImg('beans')" alt="coin" width="48" height="48" />
          </div>
        </div>
        <div class="button" @click="handleClosePopup">OK</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { apiSigninList, apiSubmitSignin } from '@/api/imee.js'

export default {
  name: 'SevenKeepSignin',
  data() {
    return {
      listLoading: true,
      submitDisable: false,
      submitLoading: false,
      rewardsList: [],
      popupVisible: false,
      rewardsInfo: {}, // 签到成功弹窗的信息
      timeStampTimer: null,
      expireTimeStamp: 0, // 倒计时剩余秒数
      currencyCode: '$', // 货币符号代码
      beansAmount: 0, // 我的豆子余额
      currencyAmount: 0, // 豆子等于多少钱, 单位：分
      fullSignRewardConfig: {}, // 最终签到内容
      ifFullSign: false, // 是否全部签满
      currentDay: 1 // 当前第几天
    }
  },
  created() {
    this.loadGoogleFont('Lato', [300, 400, 700])
  },
  mounted() {
    this.handleSubmitSignin(true)
  },
  computed: {
    /**
     * @description 时间戳格式转换
     */
    handleFormatCountdown() {
      let seconds = this.expireTimeStamp || 0
      if (!seconds || seconds <= 0) {
        return '00:00:00'
      }
      const days = Math.floor(seconds / (3600 * 24))
      const hours = Math.floor((seconds % (3600 * 24)) / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      seconds = seconds % 60

      if (days > 0 || hours > 24) {
        // 大于24小时的情况
        return `${days}d ${hours}h ${minutes}m`
      } else {
        // 小于等于24小时的情况
        const hh = String(hours).padStart(2, '0')
        const mm = String(minutes).padStart(2, '0')
        const ss = String(seconds).padStart(2, '0')
        return `${hh}:${mm}:${ss}`
      }
    }
  },
  methods: {
    /**
     * @description 获取签到列表
     */
    async handleGetList() {
      try {
        this.listLoading = true
        const res = await apiSigninList()
        if (res && res.rewardCfgList) {
          // 赋值倒计时
          this.expireTimeStamp = this.handleCalculateSecondsDifference(res.expireTimeStamp)
          if (this.expireTimeStamp > 0) {
            this.handleStartCountdown()
          }
          // 赋值列表
          this.rewardsList = res.rewardCfgList || []

          this.rewardsList.forEach((item) => {
            if (item.ifCurDay && item.ifSigned) {
              this.submitDisable = true
            }
            if (item.ifCurDay) {
              this.currentDay = item.index
            }
          })
          // 赋值货币符号
          this.currencyCode = res.currencyCode || '$'
          // 赋值豆子余额
          this.beansAmount = res.beansAmount || 0
          // 赋值豆子等价的钱数
          this.currencyAmount = res.currencyAmount || 0
          // 赋值最终奖励
          this.fullSignRewardConfig = res.fullSignRewardConfig || {}
          this.ifFullSign = res.ifFullSign || false
        } else {
          this.$client.showToast(this.$t('lang.common.errorTips'))
          console.error('获取签到列表错误！')
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.listLoading = false
      }
    },
    /**
     * @description 前往【邀请好友】页面
     */
    goToInvite() {
      this.$router.replace({
        path: '/invite'
      })
    },
    /**
     * @description 前往【任务】页面
     */
    goToDaily() {
      // eslint-disable-next-line no-undef
      commandRouter.postMessage('iMee://open_task_page')
    },
    /**
     * @description 前往【Match】页面
     */
    goToCall() {
      // eslint-disable-next-line no-undef
      commandRouter.postMessage('iMee://open_match_page')
    },
    /**
     * @description 前往【IM聊天】列表页面
     */
    goToChat() {
      // eslint-disable-next-line no-undef
      commandRouter.postMessage('iMee://open_session_page')
    },
    /**
     * @description 前往【规则】页面
     */
    goToRules() {
      this.$router.push({
        path: '/seven-keep-signin-rules',
        query: {
          fromPage: 'seven-keep-signin'
        }
      })
    },
    /**
     * @description 前往【提现】页面
     */
    goToWithdrawal() {
      this.$router.push({
        path: '/withdrawal'
      })
    },
    /**
     * @description 前往 WhatApp
     */
    goToWhatapp() {
      const link = 'https://whatsapp.com/channel/0029VbB5Kme9Bb5wCFm85T0A'
      // eslint-disable-next-line no-undef
      commandRouter.postMessage(`iMee://open_web_outside?url=${link}`)
    },
    /**
     * @description 签到提示弹窗
     */
    handleSigninTips() {
      this.popupVisible = true
    },
    /**
     * @description 提交签到
     */
    async handleSubmitSignin(isAuto) {
      // 如果加载中
      if (this.submitLoading) return
      // 如果倒计时归零了
      if (this.rewardsList.length > 0 && this.expireTimeStamp === 0) {
        this.$client.showToast(this.$t('lang.sevenKeepSignin.tips'))
        return
      }
      // 是否禁用
      if (this.submitDisable) return
      try {
        this.submitLoading = true
        const res = await apiSubmitSignin()
        if (res && (res || {}).day) {
          this.rewardsInfo = res
          this.handleSigninTips()
        } else {
          if (!isAuto) {
            this.$client.showToast(this.$t('lang.common.errorTips'))
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.submitLoading = false
        // 签到后拉一次礼物列表
        setTimeout(() => {
          this.handleGetList()
        }, 1000)
      }
    },
    /**
     * @description 关闭弹窗
     */
    handleClosePopup() {
      this.popupVisible = false
    },
    /**
     * @description 计算剩余秒数
     */
    handleCalculateSecondsDifference(timestamp) {
      const currentTime = Date.now() // 获取当前时间的时间戳（毫秒）
      const targetTime = timestamp // 目标时间的时间戳（毫秒）
      // 计算差异（毫秒），然后转换为秒
      const differenceInSeconds = Math.floor((targetTime - currentTime) / 1000)
      // 如果差异是负数，说明目标时间在当前时间之前
      if (differenceInSeconds < 0) {
        return 0 // 或者可以根据需求处理这种情况
      }
      return differenceInSeconds
    },
    /**
     * @description 倒计数
     */
    handleStartCountdown() {
      if (this.timeStampTimer) {
        clearInterval(this.timeStampTimer)
      }
      const duration = 1000
      this.timeStampTimer = setInterval(() => {
        this.expireTimeStamp--
        if (this.expireTimeStamp <= 0) {
          clearInterval(this.timeStampTimer)
          this.expireTimeStamp = 0
        }
      }, duration)
    },
    /**
     * @description 美分转美元
     */
    handleCentsToDollars(centsString) {
      const cents = Number(centsString)
      if (isNaN(cents)) {
        return centsString
      }
      return (cents / 100).toFixed(2)
    },
    /**
     * @description 加载Google字体
     */
    loadGoogleFont(fontFamily, weights) {
      // 创建一个新的 <link> 元素
      const linkElement = document.createElement('link')
      // 设置 link 元素的属性
      linkElement.rel = 'stylesheet'
      linkElement.href = `https://fonts.googleapis.com/css2?family=${fontFamily.replace(/\s/g, '+')}:wght@${weights.join(';')}&display=swap`
      // 将新的 <link> 元素添加到文档头部
      document.head.appendChild(linkElement)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
